import { render, staticRenderFns } from "./Step2Equipo.vue?vue&type=template&id=082d761c&scoped=true&lang=pug"
import script from "./Step2Equipo.vue?vue&type=script&lang=js"
export * from "./Step2Equipo.vue?vue&type=script&lang=js"
import style0 from "./Step2Equipo.vue?vue&type=style&index=0&id=082d761c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d761c",
  null
  
)

export default component.exports